/**
 * Hooks up controls for the header component
 */
export const sideButtonsScroller = (): void => {
  const miniaturesElements = document.querySelectorAll('.js-sliderMiniatures') as unknown as HTMLElement[]

  if (!miniaturesElements || miniaturesElements.length > 1 || !miniaturesElements[0] || !miniaturesElements[0].classList.contains('-hasPairing')) {
    console.log('no pairing')
    return
  }

  const miniatureWrapper = miniaturesElements[0]
  const sidebarButtons = document.querySelector('.js-sideButtonsExtras') as unknown as HTMLElement

  window.addEventListener('scroll', () => {
    checkForScroll()
  })

  window.addEventListener('resize', () => {
    checkForScroll()
  })

  const checkForScroll = () => {
    const scolledFromTop = window.scrollY
    const offsetMiniature = miniatureWrapper.offsetTop
    const miniatureHeight = miniatureWrapper.offsetHeight

    const combinedSize = offsetMiniature + miniatureHeight

    if (scolledFromTop > combinedSize) {
      sidebarButtons.classList.add('-isShown')
    } else {
      sidebarButtons.classList.remove('-isShown')
    }
  }

  checkForScroll()
}
